module.exports = __webpack_public_path__ + "img/ug.3a114d09.svg";